import Vue from "vue";
import Router from "vue-router";

import * as firebase from "firebase/app";
import store from "./store";

import Layout from "./views/Layout.vue";
import PublicLayout from "./views/PublicLayout.vue";

// page components
import Login from "./views/Login.vue";
import publicResume from "./views/public/Resume.vue";
import publicResumeAIReview from "./views/public/ResumeAIReview.vue";
import publicResumeUpload from "./views/public/ResumeUpload.vue";
// admin
import OverviewAdmin from "./views/admin/OverviewAdmin.vue";
import ConsultantAdmin from "./views/admin/ConsultantAdmin.vue";
import CompanyAdmin from "./views/admin/CompanyAdmin.vue";
import RoleAdmin from "./views/admin/RoleAdmin.vue";
import MapAdmin from "./views/admin/Map.vue";
import ProjectAdmin from "./views/admin/ProjectAdmin.vue";
import Payroll from "./views/admin/Payroll.vue";
import SettingAdmin from "./views/admin/SettingAdmin";
import AdminAvailableTechs from "./views/client/ClientAvailableTechs.vue";
import AdminActiveTechs from "./views/admin/AdminActiveTechs";
import ConsultantReview from "./views/admin/ConsultantReview.vue";
import ProjectDetail from "./views/admin/ProjectDetail";
// client
import ClientDashboard from "./views/client/ClientDashboard.vue";
import ClientInformation from "./views/client/ClientInformation.vue";
import ClientDocument from "./views/client/ClientDocument.vue";
import ClientPayment from "./views/client/ClientPayment";
import ClientAvailableTechs from "./views/client/ClientAvailableTechs.vue";
import ClientAvailableProjects from "./views/client/ClientAvailableProjects";
// consultant
import ConsultantDashboard from "./views/consultant/ConsultantDashboard.vue";
import ConsultantInterview from "./views/consultant/ConsultantInterview.vue";
import ConsultantOffer from "./views/consultant/ConsultantOffer.vue";
import ConsultantOfferFixedRate from "./views/consultant/ConsultantOfferFixedRate.vue";
import ConsultantAccept from "./views/consultant/ConsultantAccept.vue";
import ConsultantRefuse from "./views/consultant/ConsultantRefuse.vue";
import ConsultantProcessing from "./views/consultant/ConsultantProcessing.vue";
import ConsultantDocument from "./views/consultant/ConsultantDocument.vue";
import ConsultantResume from "./views/consultant/ConsultantResume.vue";
import ConsultantPayment from "./views/consultant/ConsultantPayment";
import ConsultantQuiz from "./views/consultant/ConsultantQuiz";
import ConsultantAvailableProjects from "./views/consultant/ConsultantAvailableProjects";
// other
import PublicAvailableTechs from "./views/public/PublicAvailableTechs.vue";
import CompanyGig from "./views/public/CompanyGig";
import ConsultantApply from "./views/public/ConsultantApply";
import ConsultantApplyForm from "./views/public/ConsultantApplyForm";
import ConsultantMap from "./views/public/ConsultantMap";
import NoPermission from "./views/error/NoPermission.vue";
import NoAccount from "./views/error/NoAccount.vue";
import Error404 from "./views/error/404.vue";
import NoClientPaymentAccount from "./views/error/NoClientPaymentAccount";
import NoConsultantPaymentAccount from "./views/error/NoConsultantPaymentAccount";
import Settings from "./views/settings/Settings";
import NotFollowUp from "./views/public/NotFollowUp";
import Quote from "./views/public/quote";
import AvailableProjects from "./views/public/AvailableProjects";
import ConsultantApplyNew from "./views/public/ConsultantApplyNew";
import ProjectDetailPublic from "./views/public/ProjectDetailPublic/index.vue";
import VideoAskTest from "./views/public/VideoAskTest.vue";
import ProjectDefinition from "./views/public/ProjectDefinition.vue";
import ProjectDefinitionDetail from "./views/public/ProjectDefinitionDetail.vue";

Vue.use(Router);

const router = new Router({
  // mode: "history",
  // base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Layout,
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/resume/:id/:type",
      name: "resume",
      component: publicResume,
    },
    {
      path: "/resume_ai_review/:id/:type",
      name: "resumeAIReview",
      component: publicResumeAIReview,
    },
    {
      path: "/resume_upload",
      component: publicResumeUpload,
    },
    {
      path: "/home",
      name: "settings",
      component: Layout,
      children: [{ path: "settings", component: Settings }],
      meta: { requiresAuth: true },
    },
    {
      path: "/home/admin",
      component: Layout,
      children: [
        { path: "overview_admin", component: OverviewAdmin },
        { path: "consultant_admin", component: ConsultantAdmin },
        { path: "company_admin", component: CompanyAdmin },
        { path: "role_admin", component: RoleAdmin },
        { path: "project_admin", component: ProjectAdmin },
        { path: "map", component: MapAdmin },
        { path: "payroll", component: Payroll },
        { path: "setting_admin", component: SettingAdmin },
        { path: "admin_available_techs", component: AdminAvailableTechs },
        { path: "admin_active_techs", component: AdminActiveTechs },
        { path: "consultant_review", component: ConsultantReview },
        { path: "project_detail/:id", component: ProjectDetail },
      ],
      meta: { requiresAuth: true, roles: ["admin"] },
    },
    {
      path: "/home/consultant",
      component: Layout,
      children: [
        { path: "consultant_resume", component: ConsultantResume },
        { path: "consultant_dashboard", component: ConsultantDashboard },
        { path: "consultant_document", component: ConsultantDocument },
        { path: "consultant_payment", component: ConsultantPayment },
        {
          path: "consultant_available_projects",
          component: ConsultantAvailableProjects,
        },
        {
          path: "consultant_interview",
          component: ConsultantInterview,
          meta: { noSideBar: true },
        },
        {
          path: "consultant_tech_not_interested",
          component: ConsultantInterview,
          meta: { noSideBar: true },
        },
        {
          path: "consultant_offer",
          component: ConsultantOffer,
          meta: { noSideBar: true },
        },
        {
          path: "consultant_offer_fixed_rate",
          component: ConsultantOfferFixedRate,
          meta: { noSideBar: true },
        },
        {
          path: "consultant_accept",
          component: ConsultantAccept,
          meta: { noSideBar: true },
        },
        {
          path: "consultant_refuse",
          component: ConsultantRefuse,
          meta: { noSideBar: true },
        },
        {
          path: "consultant_processing",
          component: ConsultantProcessing,
          meta: { noSideBar: true },
        },
        {
          path: "consultant_processing_interview",
          component: ConsultantProcessing,
          meta: { noSideBar: true },
        },
        {
          path: "consultant_quiz",
          component: ConsultantQuiz,
          meta: { noSideBar: true },
        },
      ],
      meta: { requiresAuth: true, roles: ["admin", "consultant"] },
    },
    {
      path: "/home/client",
      component: Layout,
      children: [
        { path: "client_dashboard", component: ClientDashboard },
        { path: "client_information", component: ClientInformation },
        { path: "client_document", component: ClientDocument },
        { path: "client_payment", component: ClientPayment },
        { path: "client_available_techs", component: ClientAvailableTechs },
        {
          path: "client_available_projects",
          component: ClientAvailableProjects,
        },
      ],
      meta: { requiresAuth: true, roles: ["admin", "client"] },
    },
    {
      path: "/home",
      component: Layout,
      children: [
        { path: "no_permission", component: NoPermission },
        { path: "no_account", component: NoAccount },
        {
          path: "no_client_payment_account",
          component: NoClientPaymentAccount,
        },
        {
          path: "no_consultant_payment_account",
          component: NoConsultantPaymentAccount,
        },
        { path: "404", component: Error404 },
      ],
    },
    {
      path: "/public",
      component: PublicLayout,
      children: [
        {
          path: "available_techs/:type",
          name: "public_available_techs",
          component: PublicAvailableTechs,
        },
      ],
    },
    {
      path: "/projectDefinition",
      component: ProjectDefinition,
    },
    {
      path: "/projectDefinitionDetail",
      component: ProjectDefinitionDetail,
    },
    {
      path: "/quote",
      component: Quote,
    },
    {
      path: "/company_gig",
      component: CompanyGig,
    },
    {
      path: "/consultant_apply",
      component: ConsultantApply,
    },
    {
      path: "/consultant_apply_new",
      component: ConsultantApplyNew,
    },
    {
      path: "/consultant_apply/:gig",
      component: ConsultantApply,
    },
    {
      path: "/consultant_apply_form",
      component: ConsultantApplyForm,
    },
    {
      path: "/consultant_apply_form/:gig",
      component: ConsultantApplyForm,
    },
    {
      path: "/project_detail_public/:id/:type",
      component: ProjectDetailPublic,
    },
    {
      path: "/consultant_map/:type",
      component: ConsultantMap,
    },
    {
      path: "/list_of_jobs",
      component: AvailableProjects,
    },
    {
      path: "/available_projects",
      component: AvailableProjects,
    },
    {
      path: "/not_follow_up",
      component: NotFollowUp,
    },
    {
      path: "/video_ask_test",
      component: VideoAskTest,
    },
    {
      path: "/no_account",
      component: NoAccount,
    },
    {
      path: "/404",
      component: Error404,
    },
    {
      path: "/home/*",
      redirect: "/home/404",
    },
    {
      path: "/*",
      redirect: "/404",
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((r) => r.meta.noSideBar)) {
    store.commit("setSidebarStatus", false);
  } else {
    store.commit("setSidebarStatus", true);
  }
  let isAuthenticated = firebase.auth().currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresRoles = to.matched.find((record) => record.meta.roles);
  if (requiresAuth && !isAuthenticated) {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        next("/login");
      } else {
        isAuthenticated = user;
        if (requiresRoles) {
          const roles = requiresRoles.meta.roles;
          firebase
            .auth()
            .currentUser.getIdTokenResult()
            .then((idTokenResult) => {
              for (const i in roles) {
                if (idTokenResult.claims[roles[i]]) {
                  next();
                  return;
                }
              }
              next("/home/no_permission");
            });
        } else {
          next();
        }
      }
    });
  } else if (isAuthenticated && requiresAuth && requiresRoles) {
    const roles = requiresRoles.meta.roles;
    firebase
      .auth()
      .currentUser.getIdTokenResult()
      .then((idTokenResult) => {
        for (const i in roles) {
          if (idTokenResult.claims[roles[i]]) {
            next();
            return;
          }
        }
        next("/home/no_permission");
      });
  } else {
    next();
  }
});

export default router;
